const LATIN_MAP: Record<string, string> = {
  a: 'а',
  b: 'б',
  v: 'в',
  g: 'г',
  d: 'д',
  e: 'е',
  yo: 'ё',
  zh: 'ж',
  z: 'з',
  i: 'и',
  y: 'й',
  k: 'к',
  l: 'л',
  m: 'м',
  n: 'н',
  o: 'о',
  p: 'п',
  r: 'р',
  s: 'с',
  t: 'т',
  u: 'у',
  f: 'ф',
  kh: 'х',
  h: 'х',
  ts: 'ц',
  c: 'ц',
  ch: 'ч',
  sh: 'ш',
  sch: 'щ',
  yu: 'ю',
  ya: 'я',
};

const COMBINED_LATIN_MAP: Record<string, string> = {
  ch: 'ч',
  sh: 'ш',
  sch: 'щ',
  kh: 'х',
  h: 'х',
  yu: 'ю',
  ya: 'я',
  yo: 'ё',
  zh: 'ж',
  ts: 'ц',
  c: 'ц',
  iya: 'ия',
  ye: 'ые',
  ie: 'ые',
  iy: 'ый',
};

const CYRILLIC_MAP: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
};

const COMBINED_CYRILLIC_MAP: Record<string, string> = {
  ё: 'e',
  ж: 'zh',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ю: 'yu',
  я: 'ya',
  э: 'e',
  ия: 'iya',
  ые: 'ye',
  ый: 'y',
};

const transliterate = {
  latinMap: LATIN_MAP,
  combinedLatinMap: COMBINED_LATIN_MAP,
  cyrillicMap: CYRILLIC_MAP,
  combinedCyrillicMap: COMBINED_CYRILLIC_MAP,
};

export { transliterate };
